const Images = {
    planta: require('./oben_2.jpg'),
    test: require('./oben.jpg'),
    white: require('./logo_white.png'),
    rollos: require('./Rollos.jpg'),
    logo: require('./logo.png'),
}

export default Images